const localizers = {
  'Alerts.noAlerts.txt': () => `Za ovo izvješće nisu postavljena upozorenja.`,
  'BirdImage.image.txt': () => `Slika`,
  'ComboBox.clearFilter.txt': () => `Očisti filtar`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Nema podataka)`,
  'ContextMenu.selectAll.txt': () => `Odaberi sve`,
  'ContextMenu.clearSelection.txt': () => `Očisti odabir`,
  'ContextMenu.exportImage.txt': () => `Izvezi kao sliku`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: uzlazno`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: silazno`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: dodaj uzlazno`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: dodaj silazno`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Ukloni stavku ${role} iz sortiranja`,
  'ContextMenu.removeSortLevel.txt': () => `Ukloni razinu sortiranja`,
  'ContextMenu.sort.txt': () => `Sortiraj`,
  'ContextMenu.selectShortestPath.txt': () => `Odaberi najkraći put`,
  'ContextMenu.explain.txt': () => `Objasni podatke`,
  'ContextMenu.explainRole.txt': ({role}) => `Objasni stavku ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Upravljanje stupcima`,
  'DrillableTooltip.drill.txt': () => `PRETRAŽI KROZ RAZINE`,
  'DrillableTooltip.tooltip.txt': () => `OPIS ELEMENATA`,
  'DrillableTooltip.links.txt': () => `VEZE`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Veza na stranicu do ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Veza na izvješće do ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Vanjska veza do ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Nije dostupno`,
  'Breadcrumb.all.fmt': ({label}) => `Sve ${label}`,
  'BrowserCheck.title.txt': () => `WebGL provjera`,
  'BrowserCheck.msg.txt': () => `WebGL je onemogućen ili ga vaš preglednik ne podržava.   \nKliknite U redu da biste izvješće prikazali u klasičnom pregledniku.`,
  'EmailUtil.subject.multiple.txt': () => `Izvješća za pregled`,
  'EmailUtil.tooLongEmail.txt': () => `Prekoračena je duljina poruke e-pošte. Odaberite manji broj izvješća za slanje e-poštom.`,
  'HiddenSectionDialog.close.txt': () => `Zatvori`,
  'HiddenSectionDialog.export.txt': () => `Izvezi kao PDF`,
  'InfoPanel.information.txt': () => `Informacije`,
  'InfoPanel.comments.txt': () => `Komentari`,
  'InfoPanel.alerts.txt': () => `Upozorenja`,
  'IncomingFilters.promptbars.txt': () => `Trake odzivnika`,
  'Information.title.txt': () => `Naslov`,
  'Information.name.txt': () => `Naziv:`,
  'Information.description.txt': () => `Opis:`,
  'Information.displayRules.txt': () => `Pravila prikaza:`,
  'Information.graphLevel.txt': () => `Razina grafikona`,
  'Information.reportLevel.txt': () => `Razina izvješća`,
  'Information.legend.txt': () => `Legenda`,
  'Information.incomingFilters.txt': () => `Ulazni filtri:`,
  'Information.noIncomingFilters.txt': () => `Nema ulaznih filtara`,
  'Information.dataSourceFilters.txt': () => `Filtri izvora podataka:`,
  'Information.interactiveFilters.txt': () => `Interaktivni filtri:`,
  'MobileContainer.mobileBIMessage.txt': () => `Pristupite SAS izvješćima na mobilnom uređaju.`,
  'ObjectTypes.report.txt': () => `Izvješće`,
  'ObjectTypes.Report.BI.txt': () => `SAS izvješće (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Izvješće spremljenog procesa`,
  'ObjectTypes.StoredProcess.txt': () => `Spremljeni proces`,
  'MissingValues.label.txt': () => `(nedostaju vrijednosti)`,
  'PromptContainer.apply.txt': () => `U redu`,
  'PromptContainer.cancel.txt': () => `Odustani`,
  'PromptContainer.close.txt': () => `Zatvori`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Vrijednost mora biti broj između ${min} i ${max}, uključujući i te brojeve.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Navedite valjanu numeričku vrijednost.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Vrijednost nije valjana za dodijeljene podatke`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Unos: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Unos: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Unos ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} – ${max}`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Natrag`,
  'ReportContainer.reportCorrupted.txt': () => `IZVJEŠĆE OŠTEĆENO`,
  'ReportContainer.themeLoadFailed.txt': () => `Tema izvješća nije uspješno učitana.`,
  'ReportContainer.restoreButton.tip.txt': () => `Vrati izvješće`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Izvješće vraćeno`,
  'ReportContainer.renderError.txt': () => `Došlo je do pogreške. Nije moguće prikazati izvješće.`,
  'ReportContainer.component.renderError.txt': () => `Došlo je do pogreške. Komponentu nije moguće renderirati.`,
  'ReportContentPage.open.txt': () => `Otvori...`,
  'ReportContentPage.refreshReport.txt': () => `Osvježi izvješće`,
  'ReportContentPage.editReport.txt': () => `Uredi izvješće`,
  'ReportContentPage.print.txt': () => `Ispis...`,
  'ReportContentPage.email.txt': () => `E-pošta...`,
  'ReportContentPage.export.txt': () => `Izvezi u Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Svojstva izvješća`,
  'ReportContentPage.shareReport.txt': () => `Dijeli izvješće`,
  'ReportContentPage.enableOverlays.txt': () => `Omogući preklapanja objekata`,
  'ReportContentPage.disableOverlays.txt': () => `Onemogući preklapanja objekata`,
  'ReportContentPage.link.txt': () => `Veza...`,
  'ReportContentPage.settings.txt': () => `Postavke...`,
  'ReportContentPage.editPlayback.txt': () => `Uredi reproduciranje`,
  'ReportContentPage.playReport.txt': () => `Pokreni izvješće`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Prikaži odzivne filtre`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Sakrij odzivne filtre`,
  'ReportContentPage.reportFilters.txt': () => `Razina izvješća`,
  'ReportContentPage.pageFilters.txt': () => `Razina stranice`,
  'ReportContentPage.refreshRequired.txt': () => `Potrebno je osvježavanje izvješća`,
  'ReportContentPage.infoButton.tip.txt': () => `Ploča informacija`,
  'ReportContentPage.backButton.tip.txt': () => `Prikaži sva izvješća`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Više mogućnosti`,
  'ReportContentPage.itemGroupName.txt': () => `Izvješća`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Maksimiziraj izvješće`,
  'ReportContentPage.closeButton.txt': () => `Zatvori izvješće`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Izvješće maksimizirano`,
  'ReportContentPage.resetReportState.txt': () => `Vrati zadano stanje izvješća`,
  'ReportContentPage.summary.txt': () => `Prikaži sažetak`,
  'ReportManagerPage.objectMenu.open.txt': () => `Otvori`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Uredi`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Sažetak`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Svojstva`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-pošta...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Ispis`,
  'ReportManagerPage.browseReportsButton.txt': () => `Pregledaj izvješća`,
  'ReportManagerPage.newReportButton.txt': () => `Novo izvješće`,
  'ReportManagerPage.emptyView.message.txt': () => `Nije pronađeno nijedno izvješće.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Potraži izvješća`,
  'ReportManagerPage.tableView.name.txt': () => `Naziv`,
  'ReportManagerPage.tableView.author.txt': () => `Autor`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Posljednja izmjena`,
  'ReportManagerPage.openButton.tip.txt': () => `Otvori izvješće`,
  'ReportManagerPage.emailButton.tip.txt': () => `Pošalji izvješće e-poštom`,
  'ReportManagerPage.printButton.tip.txt': () => `Ispiši izvješće u PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Svojstva izvješća`,
  'ReportObject.multipleReferences.error.txt': () => `Objekti izvješća ne mogu se koristiti u više konteksta.`,
  'ReportObject.notFound.error.txt': () => `U navedenom izvješću nije moguće pronaći naziv objekta.`,
  'ReportObject.invalidPage.error.txt': () => `Navedena stranica nije valjana.`,
  'ReportPropertiesDialog.open.txt': () => `Otvori`,
  'ReportPropertiesDialog.close.txt': () => `Zatvori`,
  'ReportPropertiesDialog.name.txt': () => `Naziv:`,
  'ReportPropertiesDialog.description.txt': () => `Opis:`,
  'ReportPropertiesDialog.keywords.txt': () => `Ključne riječi:`,
  'ReportPropertiesDialog.type.txt': () => `Vrsta:`,
  'ReportPropertiesDialog.location.txt': () => `Mjesto:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Stvorio:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Datum stvaranja:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Izmijenio:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Datum izmjene:`,
  'ReportSections.newPageButton.txt': () => `Nova stranica`,
  'ReportSections.closeTab.tooltip.txt': () => `Izbriši stranicu`,
  'ReportSummaryDialog.title.txt': () => `Sažetak`,
  'ReportSummaryDialog.open.txt': () => `Otvori`,
  'ReportSummaryDialog.cancel.txt': () => `Odustani`,
  'ReportSummaryDialog.close.txt': () => `Zatvori`,
  'ReportSummaryDialog.noSummary.txt': () => `Nije dostupan nijedan sažetak.`,
  'ReportTileBody.modifiedBy.txt': () => `Izmijenio:`,
  'ReportTileBody.lastModified.txt': () => `Posljednja izmjena:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Preglednik izvješća`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Osvježavanje izvješća`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Automatsko osvježavanje izvješća`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Potraži ažuriranja nakon ovoliko minuta:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Obavijesti upozorenja`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Odaberite zadane obavijesti upozorenja:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Pošalji poruke e-pošte`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Pošalji SMS poruke`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Administratorski zadano`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Teme`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Zamijeni temu izvješća i upotrebljavaj temu izvješća SAS High Contrast`,
  'ViewerBusyDialog.openReport.txt': () => `Otvaranje izvješća...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Izvješće u pripremi...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Priprema za ispis...`,
  'PDFGeneration.printingReport.txt': () => `Generiranje PDF-a izvješća. Preuzet će se kad bude spremno.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `Datoteka${fileName}, dana ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Odaberi radnju`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Dosegnuli ste najnižu razinu hijerarhije.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Dosegnuli ste najnižu razinu svih hijerarhija.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Pretraži kroz razine ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Snimka stavke ${a0} ${a1} na ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Spremi sliku`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Ispis objekta...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Dijeli objekt...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Više`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Izbornik objekata za ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Prikaži pomoću ubrzivača SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Zumiraj`,
  'ZoomControl.button.zoomin.txt': () => `Povećaj`,
  'ZoomControl.button.zoomout.txt': () => `Smanji`,
  'ZoomControl.button.display.txt': () => `Kontrole zooma`,
  'ZoomControl.button.reset.txt': () => `Vrati na izvorne postavke zumiranja`,
  'ExpandControl.button.expand.txt': () => `Maksimiziraj prikaz`,
  'ExpandControl.button.restore.txt': () => `Vrati prikaz`,
  'ExpandControl.button.expand.tip.txt': () => `Maksimiziraj`,
  'ExpandControl.button.restore.tip.txt': () => `Vrati`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Veze na stranicu ne mogu se izvršiti dok je ovaj objekt maksimiziran.`,
  'DragModeControl.button.pan.tip.txt': () => `Panoramski prikaz`,
  'DragModeControl.button.circular.tip.txt': () => `Kružni odabir`,
  'DragModeControl.button.freeform.tip.txt': () => `Slobodni odabir`,
  'DragModeControl.button.rectangular.tip.txt': () => `Pravokutni odabir`,
  'DragModeControl.button.zoom.tip.txt': () => `Zumiraj na pravokutnik`,
  'ReportXMLDialog.title.txt': () => `XML izvješća`,
  'ReportXMLDialog.closeButton.txt': () => `Zatvori`,
  'ReportXMLDialog.copyButton.txt': () => `Kopiraj u međuspremnik`,
  'ReportXMLDialog.error.txt': () => `Pogreška u učitavanju XML-a izvješća`,
  'ErrorDialog.error.txt': () => `Došlo je do pogreške. Obratite se administratoru sustava.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics – Report Viewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Otvori izvješće`,
  'OpenReportDialog.reports.txt': () => `Izvješća:`,
  'OpenReportDialog.cancel.txt': () => `Odustani`,
  'OpenReportDialog.ok.txt': () => `U redu`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `Broj ažuriranih objekata:${count}`,
  'AriaLive.oneObjectUpdated.txt': () => `1 objekt ažuriran`,
  'AriaLive.reportOpened.txt': () => `Izvješće otvoreno`,
  'AriaLive.reportClosed.txt': () => `Izvješće zatvoreno`,
  'ExportData.generating.txt': () => `Generiranje izvoza. Preuzet će se kad bude spremno.`,
  'ExportData.warning.txt': () => `Pogreška pri generiranju podataka`,
  'ExportData.nodata.txt': () => `Nema podataka za izvoz`,
  'ExportData.exportData.txt': () => `Izvezi podatke...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Spremi`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Odustani`,
  'PlaybackAnimationDialog.playButton.txt': () => `Pokreni izvješće`,
  'PlaybackAnimationDialog.title.txt': () => `Uredi reproduciranje`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Prijelazna jedinica:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Stranica`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Objekt`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Sekunde po jedinici:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Prikaži povećane objekte:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Prikaži samo platno:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Prikaži brojač vremena:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Prikaži kontrole za navigaciju nakon klika ili dodira:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Prethodna stranica`,
  'PlaybackNavigationControls.nextPage.txt': () => `Sljedeća stranica`,
  'PlaybackNavigationControls.previousObject.txt': () => `Prethodni objekt`,
  'PlaybackNavigationControls.nextObject.txt': () => `Sljedeći objekt`,
  'TransportConnection.generateReportTimeout.txt': () => `Učitavanje izvješća predugo traje. Želite li nastaviti?`,
  'TransportConnection.openReport.txt': () => `Otvori izvješće`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Ne postoji navedeno izvješće na sljedećem mjestu: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Proširi ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Sažmi ${label}`,
  'GraphElementDecorator.overview.txt': () => `Pregled`,
  'GraphElementDecorator.layers.txt': () => `Sakrij ili prikaži slojeve`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Sakrij pregled`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Prikaži pregled`,
  'TitleInfoButton.tooltip.txt': () => `Informacije`,
  'SectionSelectionBar.noSelections.txt': () => `Nema odabira`,
  'SectionSelectionBar.title.txt': () => `Filtri:`,
  'CheckboxList.selectAll.txt': () => `Odaberi sve`,
  'CheckboxList.clearSelection.txt': () => `Očisti odabir`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Očisti odabir (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Objašnjava se ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Priprema objašnjenja...`,
  'ExplanationInfoDialog.cancel.txt': () => `Odustani`,
  'ExplanationInfoDialog.close.txt': () => `Zatvori`,
  'PromptHeader.emptyReport.txt': () => `Povucite podatkovnu stavku ili kontrolu ovdje da biste izradili pregled mogućnosti izvješća.`,
  'PromptHeader.emptyPage.txt': () => `Povucite podatkovnu stavku ili kontrolu ovdje da biste izradili pregled mogućnosti stranice.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Sažmi regulacijsko područje stranice`,
  'PromptHeader.expandPageControlArea.txt': () => `Proširi regulacijsko područje stranice`,
  'PromptHeader.collapseReportControlArea.txt': () => `Sažmi regulacijsko područje izvješća`,
  'PromptHeader.expandReportControlArea.txt': () => `Proširi regulacijsko područje izvješća`,
  'PromptHeader.collapseControlArea.txt': () => `Sažmi regulacijsko područje`,
  'PromptHeader.expandControlArea.txt': () => `Proširi regulacijsko područje`,
  'PromptHeader.reportControlArea.txt': () => `Regulacijsko područje izvješća`,
  'PromptHeader.allControlAreas.txt': () => `Sva regulacijska područja`,
  'PromptHeader.pageControlArea.txt': () => `Regulacijsko područje stranice`,
  'ZeroState.editMode.txt': () => `Povucite predložak, podatkovne stavke ili objekte ovdje.`,
  'ZeroState.viewMode.txt': () => `Nema sadržaja za prikaz.`,
  'ObjectStatus.assignData.txt': () => `Dodijeli podatke`,
  'ObjectStatus.selectImage.txt': () => `Odaberi sliku`,
  'ObjectStatus.selectJob.txt': () => `Odaberi zadatak`,
  'ObjectStatus.cancelLoading.txt': () => `Otkaži učitavanje`,
  'ObjectStatus.loadingCanceled.txt': () => `Učitavanje otkazano`,
  'ObjectStatus.resumeLoading.txt': () => `Nastavi učitavanje`,
  'ObjectStatus.refresh.txt': () => `Osvježi`,
  'ObjectStatus.setJobParameters.txt': () => `Postavi vrijednosti parametara`,
  'ObjectSearch.title.txt': () => `Geografsko pretraživanje`,
  'ObjectSearch.pin.txt': () => `Prikvači`,
  'ObjectSearch.unpin.txt': () => `Otkvači`,
  'MainSearchPanel.searchResults.txt': () => `Rezultati pretraživanja`,
  'MainSearchPanel.features.txt': () => `Značajke`,
  'MainSearchPanel.pin.txt': () => `Nova oznaka`,
  'MainSearchPanel.pin.tooltip.txt': () => `Nova oznaka`,
  'MainSearchPanel.route.txt': () => `Nova ruta`,
  'MainSearchPanel.route.tooltip.txt': () => `Nova ruta`,
  'MainSearchPanel.geographicArea.txt': () => `Novo geografsko područje`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Novo geografsko područje`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Moja oznaka lokacije`,
  'MainSearchPanel.myLocationPin.txt': () => `Moja lokacija`,
  'MainSearchPanel.show.txt': () => `Prikaži`,
  'MainSearchPanel.show.all.txt': () => `Prikaži sve`,
  'MainSearchPanel.hide.txt': () => `Sakrij`,
  'MainSearchPanel.hide.all.txt': () => `Sakrij sve`,
  'MainSearchPanel.delete.txt': () => `Izbriši`,
  'MainSearchPanel.delete.all.txt': () => `Izbriši sve`,
  'MainSearchPanel.convert.txt': () => `Pretvaranje rezultata pretraživanja u oznake`,
  'MainSearchPanel.convert.all.txt': () => `Pretvaranje svih rezultata pretraživanja u oznake`,
  'MainSearchPanel.showPinLabels.txt': () => `Prikaži naljepnice oznaka`,
  'MainSearchPanel.close.label.txt': () => `Geografsko pretraživanje`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Prikaži pojedinosti`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Demografija`,
  'PanelHeader.back.tooltip.txt': () => `Natrag`,
  'GeographicAreaPanel.title.txt': () => `Geografsko područje`,
  'GeographicAreaPanel.draw.txt': () => `Područje crtanja`,
  'GeographicAreaPanel.update.txt': () => `Ažuriraj područje`,
  'GeographicAreaPanel.label.txt': () => `Oznaka:`,
  'GeographicAreaPanel.location.txt': () => `Mjesto:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Udaljenost (milje):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Udaljenost (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Dodaj udaljenost`,
  'GeographicAreaPanel.time.add.txt': () => `Dodaj vrijeme`,
  'GeographicAreaPanel.distance.delete.txt': () => `Izbriši udaljenost`,
  'GeographicAreaPanel.time.minutes.txt': () => `Vrijeme (min):`,
  'GeographicAreaPanel.duration.txt': () => `Trajanje:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Milje`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometri`,
  'GeographicAreaPanel.menu.clear.txt': () => `Očisti geografsko područje`,
  'GeographicAreaPanel.menu.link.txt': () => `Poveži adresu s podatkovnim elementima i oznakama prema zadanim postavkama`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Poništiti vezu adrese geografskog područja`,
  'GeographicAreaPanel.menu.delete.txt': () => `Izbriši geografsko područje`,
  'GeographicAreaPanel.demographics.txt': () => `Demografija`,
  'GeographicAreaPanel.demographics.set.txt': () => `Prikaži demografiju`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Proširi prikaz`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Uređivanje demografije`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Brisanje demografije`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Podaci o demografiji moraju se ponovno učitati`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Ponovno učitavanje demografije`,
  'GeographicAreaPanel.invalid.location.txt': () => `Geografsko područje ne sadrži valjanu lokaciju i ne može se izraditi.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Odaberite dan i vrijeme`,
  'TravelTypeField.cancel.txt': () => `Odustani`,
  'TravelTypeField.ok.txt': () => `U redu`,
  'TravelTypeField.button.tooltip.txt': () => `Odaberite dan i vrijeme`,
  'TravelTypeField.day.txt': () => `Dan:`,
  'TravelTypeField.time.txt': () => `Vrijeme:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Izravno`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Udaljenost`,
  'TravelTypeField.travelType.txt': () => `Vrsta puta:`,
  'TravelTypeField.traffic.txt': () => `Uključi promet:`,
  'TravelTypeField.traffic.offset.txt': () => `Pomak vremena puta:`,
  'TravelTypeField.traffic.daytime.txt': () => `Dan i vrijeme puta:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Jedinica za udaljenost`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Udaljenost za vožnju`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Vrijeme vožnje`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Udaljenost za prijevoz kamionom`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Vrijeme za prijevoz kamionom`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Udaljenost za hodanje`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Vrijeme za hodanje`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Ne`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Trenutačan promet`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Tipičan promet`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} h`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Ažuriraj promet za tu značajku`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Ažuriraj promet za sve značajke`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Ažuriraj podatke o prometu`,
  'RoutePanel.title.txt': () => `Ruta`,
  'RoutePanel.draw.txt': () => `Crtanje rute`,
  'RoutePanel.update.txt': () => `Ažuriraj rutu`,
  'RoutePanel.label.txt': () => `Oznaka:`,
  'RoutePanel.locations.txt': () => `Lokacije`,
  'RoutePanel.menu.clear.txt': () => `Očisti rutu`,
  'RoutePanel.menu.reverse.txt': () => `Obrnuta ruta`,
  'RoutePanel.menu.add.waypoint.txt': () => `Dodaj lokaciju na ruti`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Izbriši lokaciju na ruti`,
  'RoutePanel.menu.unlink.txt': () => `Poništavanje veze lokacije na ruti`,
  'RoutePanel.menu.arrows.txt': () => `Strelice rute`,
  'RoutePanel.menu.arrows.hide.txt': () => `Sakrivanje strelica rute`,
  'RoutePanel.menu.arrows.show.txt': () => `Prikazivanje strelica rute`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Jednosmjerno`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Dvosmjerno`,
  'RoutePanel.menu.delete.txt': () => `Izbriši rutu`,
  'RoutePanel.route.width.txt': () => `Širina rute`,
  'RoutePanel.distance.txt': () => `Udaljenost:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} milja`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Dodaj lokaciju`,
  'RoutePanel.location.delete.txt': () => `Izbriši lokaciju`,
  'RoutePanel.duration.txt': () => `Vrijeme:`,
  'RoutePanel.invalid.location.txt': () => `Ruta nema valjanih mjesta i ne može se izraditi.`,
  'PinPanel.pinTitle.txt': () => `Prikvači`,
  'PinPanel.addDescription.txt': () => `Dodaj opis`,
  'PinPanel.deleteDescription.txt': () => `Brisanje opisa`,
  'PinPanel.newPin.txt': () => `Nova oznaka na ovoj lokaciji`,
  'PinPanel.deletePin.txt': () => `Izbriši oznaku`,
  'PinPanel.linkPins.txt': () => `Poveži oznake s podatkovnim elementima prema zadanim postavkama`,
  'PinPanel.unlinkAllItems.txt': () => `Poništi vezu svih stavki`,
  'PinPanel.unlinkItems.txt': () => `Poništi vezu stavki`,
  'PinPanel.label.txt': () => `Oznaka:`,
  'PinPanel.location.txt': () => `Mjesto:`,
  'PinPanel.description.txt': () => `Opis:`,
  'PinPanel.linked.txt': () => `POVEZANO`,
  'PinPanel.searchClickPlaceholder.txt': () => `Potražite ili odaberite na karti`,
  'PinPanel.searchPlaceholder.txt': () => `Pretraži`,
  'PinPanel.addRoute.txt': () => `Dodaj rutu`,
  'PinPanel.addRoute.tooltip.txt': () => `Dodaj rutu`,
  'PinPanel.addArea.txt': () => `Dodaj geografsko područje`,
  'PinPanel.addArea.tooltip.txt': () => `Dodaj geografsko područje`,
  'PinPanel.addArea.title.txt': () => `Dodaj geografsko područje`,
  'PinPanel.myLocationTitle.txt': () => `Moja oznaka lokacije`,
  'PinPanel.deleteMyLocationPin.txt': () => `Izbriši moju oznaku lokacije`,
  'PinPanel.enableAutoUpdate.txt': () => `Omogući automatsko ažuriranje moje lokacije`,
  'PinPanel.disableAutoUpdate.txt': () => `Onemogući automatsko ažuriranje moje lokacije`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Uredi interval automatskog osvježavanja moje lokacije...`,
  'PinPanel.linkToPin.txt': () => `Veza s prikvačivanjem`,
  'PinPanel.useCurrentLocation.txt': () => `Upotrijebi trenutnu lokaciju oznake`,
  'PinPanel.notDrawn.txt': () => `Nije nacrtano`,
  'PinPanel.undetermined.txt': () => `Neodređeno`,
  'PinPanel.findMyLocation.txt': () => `Pronađi Moju lokaciju`,
  'PinPanel.cannotDetermineLocation.txt': () => `Aplikacija ne može utvrditi vašu trenutnu lokaciju. Ako želite podijeliti svoju lokaciju, pogledajte pomoć za svoj preglednik ili uređaj.`,
  'PinPanel.autoRefreshInterval.txt': () => `Interval automatskog osvježavanja moje lokacije`,
  'PinPanel.interval.hours.txt': () => `Sati:`,
  'PinPanel.interval.minutes.txt': () => `Minute:`,
  'PinPanel.interval.seconds.txt': () => `Sekunde:`,
  'PinPanel.invalid.location.txt': () => `Oznaka ne sadrži valjanu lokaciju i ne može se izraditi.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mi`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mi`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mi`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min`,
  'DiscardChangesDialog.title.area.txt': () => `Geografsko područje`,
  'DiscardChangesDialog.title.route.txt': () => `Ruta`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Unijeli ste izmjene u geografsko područje ali niste iznova ucrtali područje.\n\nŽelite li odbaciti promjene stavke ${label}?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Unijeli ste izmjene u geografsko područje ali niste iznova ucrtali rutu.\n\nŽelite li odbaciti promjene stavke ${label}?`,
  'DiscardChangesDialog.discard.txt': () => `Odbaci`,
  'DiscardChangesDialog.cancel.txt': () => `Otkaži`,
  'DemographicsSelectorDialog.title.txt': () => `Prikaži demografiju`,
  'DemographicsSelectorDialog.cancel.txt': () => `Odustani`,
  'DemographicsSelectorDialog.ok.txt': () => `U REDU`,
  'DemographicsSelectorDialog.country.txt': () => `Država/regija`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Osnovno`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Napredno`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Nedavno`,
  'DemographicsSelectorDialog.categories.txt': () => `Kategorije`,
  'DemographicsSelectorDialog.category.income.txt': () => `Dohodak`,
  'DemographicsSelectorDialog.category.age.txt': () => `Dob`,
  'DemographicsSelectorDialog.category.households.txt': () => `Kućanstva`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Smještaj`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Bračno stanje`,
  'DemographicsSelectorDialog.category.population.txt': () => `Stanovništvo`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Grupa korisnika`,
  'DemographicsSelectorDialog.category.health.txt': () => `Zdravlje`,
  'DemographicsSelectorDialog.category.education.txt': () => `Obrazovanje`,
  'DemographicsSelectorDialog.category.business.txt': () => `Poslovanje`,
  'DemographicsSelectorDialog.category.race.txt': () => `Rasa`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Potrošnja`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Ponašanja`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Poslovi`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Siromaštvo`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Tapiserija`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `U opasnosti`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Ključne činjenice`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Ponuda i potražnja`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Pravilo`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Pejzaž`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Kriminalitet`,
  'ManageColumns.title.txt': () => `Upravljanje stupcima`,
  'ManageColumns.ok.txt': () => `U REDU`,
  'ManageColumns.cancel.txt': () => `Odustani`,
  'ManageColumns.hiddenColumns.txt': () => `Skriveni stupci`,
  'ManageColumns.displayedColumns.txt': () => `Prikazani stupci`,
  'SearchResultPanel.title.txt': () => `Rezultat pretraživanja`,
  'SearchResultPanel.menu.delete.txt': () => `Očisti rezultat pretraživanja`,
  'SearchResultPanel.convert.txt': () => `Pretvori u oznaku`,
  'SearchResultPanel.convert.tooltip.txt': () => `Pretvori u oznaku`,
  'DemographicsResultsDialog.title.txt': () => `Demografija`,
  'DemographicsResultsDialog.cancel.txt': () => `Odustani`,
  'DemographicsResultsDialog.close.txt': () => `Zatvori`,
  'DemographicsResultsDialog.edit.txt': () => `Uredi`,
  'DemographicsResultsDialog.layout.page.txt': () => `Rotirajući prikaz`,
  'DemographicsResultsDialog.layout.list.txt': () => `Prikaz u jednom stupcu`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Prikaz u obliku pločica`,
  'DemographicsResultsDialog.noData.txt': () => `Nijedan se podatak ne podudara s trenutačnim geografskim područjem.`,
  'PinsAtSameLocationPanel.title.txt': () => `Pribadače na istom mjestu`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `REZULTATI PRETRAŽIVANJA`,
  'PinsAtSameLocationPanel.pins.txt': () => `PRIBADAČE`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Prikaži sve`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Sakrij sve`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Izbriši sve`,
  'PinsAtSameLocationPanel.show.txt': () => `Prikaži`,
  'PinsAtSameLocationPanel.hide.txt': () => `Sakrij`,
  'PinsAtSameLocationPanel.delete.txt': () => `Izbriši`,
  'LocationPopover.pin.title.txt': () => `Prikvači lokaciju`,
  'LocationPopover.area.title.txt': () => `Lokacija geografskog područja`,
  'LocationPopover.route.title.txt': ({label}) => `Lokacija rute ${label}`,
  'LocationPopover.name.txt': () => `Naziv`,
  'LocationPopover.location.txt': () => `Mjesto:`,
  'LocationPopover.ok.txt': () => `Postavljena lokacija`,
  'LocationPopover.cancel.txt': () => `Izađi iz načina odabira`,
  'LocationPopover.hint.txt': () => `Ponovno kliknite kartu da biste postavili drugu lokaciju.`,
  'TreeDualSelector.source.default.txt': () => `Dostupne stavke`,
  'TreeDualSelector.target.default.txt': () => `Odabrane stavke`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} od ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Nema stavki`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filtar`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Prilagođena stavka`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `Broj dodanih stavki:${noOfSelectedRows}`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `Broj uklonjenih stavki:${noOfSelectedRows}`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Sve su stavke dodane`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Sve su stavke uklonjene`,
  'TreeDualSelector.afterAction.up.txt': () => `Premješteno gore`,
  'TreeDualSelector.afterAction.down.txt': () => `Premješteno dolje`,
  'TreeDualSelector.afterAction.top.txt': () => `Premješteno na vrh`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Premješteno na dno`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Radnja dodavanja vraćena je`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Radnja uklanjanja vraćena je`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `prilagođena stavka je dodana`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `Prilagođena stavka${customItemSelected} je odabrana`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected}${itemDescription} – odabrano`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} – odabrano`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Premjesti za jedan redak više na popisu ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Premjesti za jedan redak niže na popisu ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Premjesti na vrh popisa ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Premjesti na dno popisa ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Dodaj stavku na popis ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Dodaj sve na popis ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Ukloni stavku s popisa ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Ukloni sve s popisa ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Poništi dodavanje za popis ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Poništi uklanjanje za popis ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Filtar ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Ukloni`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Ako nastavite, sve prilagođene stavke koje ste odabrali za uklanjanje trajno će se izbrisati.\n\n Želite li nastaviti?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Ukloni sve stavke`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Ako nastavite, prilagođene stavke na tom popisu trajno će se izbrisati.\n\n Želite li nastaviti?`,
  'LinkNavigator.backButton.label': () => `Natrag`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Ulazni filtri`,
  'LinkNavigator.reportLevel.label': () => `Razina izvješća`,
  'LinkNavigator.sectionLevel.label': () => `Razina stranice`,
  'ReportSectionZeroState.heading.label': () => `Dizajniraj izvješće`,
  'ReportSectionZeroState.description.label': () => `Povucite objekte ili podatkovne stavke na stranicu ili odaberite mogućnost u nastavku.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Povucite objekte ili podatkovne stavke na stranicu ili započnite pomoću predloška stranice.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Generiraj objekt`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Odaberi predložak`,
  'PromptContainerTooltip.noSelections.txt': () => `Nema odabira`,
  'PromptContainerTooltip.selectedValues.txt': () => `Odabrane vrijednosti`,
}
export default localizers;
